import React from "react";
import classes from "./TextMoreLess.scss";
import PropTypes from "prop-types";
import ReactTextMoreLess from "react-text-more-less";
import I18nHOC from "UIComponents/I18nHOC";
import {
  getStringAutoLinks,
  getStyleStrippedText,
  decodeHTMLEntities,
} from "Utils";
import { Button } from "@toddle-edu/ds-web";

class TextMoreLess extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  onClick = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };
  render() {
    const { collapsed } = this.state;
    const {
      value,
      minHeight,
      customTextStyle,
      moreText,
      containerDivStyle,
      t,
      testId,
      buttonProps = {},
    } = this.props;

    const rootProps = collapsed
      ? { style: containerDivStyle, "data-test-id": testId }
      : { style: containerDivStyle };

    return (
      <ReactTextMoreLess
        collapsed={collapsed}
        rootProps={rootProps}
        text={
          collapsed ? (
            // Prevent XSS since ReactTextMoreLess uses innerHTML (collapsing state)
            // GitHub issue: https://github.com/vivaxy/react-text-more-less/issues/82
            // Use decodeHTMLEntities to properly decode HTML entities(sanitize-html)
            decodeHTMLEntities(
              getStyleStrippedText({
                text: value,
                type: "SANITIZE_DANGER_HTML_PARAGRAPH",
              })
            )
          ) : (
            <span
              dangerouslySetInnerHTML={{
                __html: getStyleStrippedText({
                  text: getStringAutoLinks(value),
                  type: "SANITIZE_DANGER_HTML_PARAGRAPH",
                }),
              }}
              data-test-id={testId}
            ></span>
          )
        }
        lessHeight={minHeight}
        showMoreText={moreText}
        showMoreElement={
          <span>
            ...{" "}
            <Button
              dsVersion="2.0"
              onClick={this.onClick}
              className={classes.showMoreText}
              style={customTextStyle}
              type="inline"
              variant="progressive"
              testId={`${testId}-showmore`}
              {...buttonProps}
            >
              {t("see_more_noDots")}
            </Button>
          </span>
        }
        showLessElement={
          <Button
            dsVersion="2.0"
            onClick={this.onClick}
            className={classes.showLessText}
            style={customTextStyle}
            type="inline"
            variant="progressive"
            testId={`${testId}-showless`}
            {...buttonProps}
          >
            {t("see_less_noDots")}
          </Button>
        }
      />
    );
  }
}

TextMoreLess.defaultProps = {
  minHeight: 72,
  moreText: "...See More",
  customTextStyle: {},
};

TextMoreLess.propTypes = {
  minHeight: PropTypes.number,
  moreText: PropTypes.string,
};

export default I18nHOC({ resource: "common" })(TextMoreLess);
